import { useTranslation } from "react-i18next";
import { NS } from "@core/libs/i18n/namespaces";
import type documents from "@core/locales/en/documents.json";

type RecursiveKeyOf<TObj extends object> = {
  [K in keyof TObj & string]: TObj[K] extends object
    ? `${K}.${RecursiveKeyOf<TObj[K]>}`
    : K;
}[keyof TObj & string];

export type ViewerKeys = RecursiveKeyOf<(typeof documents)["viewer"]>;

export function useViewerTranslate() {
  const { t: baseT } = useTranslation(NS.DOCUMENTS);

  const t = (key: ViewerKeys, opts?: Record<string, unknown>) =>
    baseT(`viewer.${key}`, opts) as string;

  return { t };
}
